
/** import external dependencies */
import $ from 'jquery';
// window.$ = window.jQuery = window.jquery = $;
global.$ = global.jQuery = global.jquery = $;  // Use global instead of window in WebPack5

/** customise bootstrap js */
// import '@popperjs/core';  // @popperjs/core required by Bootstrap js for some methods.
import 'popper.js';     // legacy popper.js required by Bootstrap js for some methods.
// import 'bootstrap';  // All Bootstrap JS methods in one import. (Unused JS)
// import 'bootstrap/js/dist/alert';
import 'bootstrap/js/dist/button';
// import 'bootstrap/js/dist/carousel';
import 'bootstrap/js/dist/collapse'; // required by dropdown
import 'bootstrap/js/dist/dropdown'; // would require @popperjs/core
import 'bootstrap/js/dist/index';
import 'bootstrap/js/dist/modal';
// import 'bootstrap/js/dist/popover';  // would require @popperjs/core
// import 'bootstrap/js/dist/scrollspy';
// import 'bootstrap/js/dist/tab';
// import 'bootstrap/js/dist/toast';
import 'bootstrap/js/dist/tooltip'; // would require @popperjs/core
import 'bootstrap/js/dist/util';


/** import local dependencies */
import moveClassesToBody from './UM-Base/lib/bodyClassMover';
import debugLogger from './UM-Base/lib/debugLogger';
import ComponentRouter from './UM-Base/util/ComponentRouter';
import Router from './UM-Base/util/Router';

// Import SA specific
import common from './SA/routes/common';
import AddToTripModal from './UM-Base/components/AddToTripModal';
import Analytics from './UM-Base/components/Analytics';
import BookingReviews from './UM-Base/components/BookingReviews';
import ModalToInternationalSite from './UM-Base/components/ModalToInternationalSite';
import OidcLogout from './UM-Base/components/OidcLogout';
import OidcSignin from './UM-Base/components/OidcSignin';
import OidcSilentSignin from './UM-Base/components/OidcSilentSignin';
import TripPlanModal from './UM-Base/components/TripPlanModal';

// Import components
import Alerts from './UM-Base/components/Alerts';
import AnalyticsOdp from './UM-Base/components/AnalyticsOdp';
import BackToTop from './UM-Base/components/BackToTop';
import BannerCarousel from './UM-Base/components/BannerCarousel';
import BlogLegend from './UM-Base/components/BlogLegend';
import RecentBlogViews from './UM-Base/components/RecentBlogViews';
import RecentBlogsCarousel from './UM-Base/components/RecentBlogsCarousel';
import ChatBotLaunch from './UM-Base/components/ChatBotLaunch';
import Countdown from './UM-Base/components/Countdown';
import DataEvents from './UM-Base/components/DataEvents';
import DeviceResCookie from './UM-Base/components/DeviceResCookie';
import FavButton from './UM-Base/components/FavButton';
import FitVid from './UM-Base/components/FitVid';
import FooterLanguageLinks from './UM-Base/components/FooterLanguageLinks';
import Form from './UM-Base/components/Form';
import Header from './UM-Base/components/Header';
import HeaderSearch from './UM-Base/components/HeaderSearch';
import ImageParallax from './UM-Base/components/ImageParallax';
import ImageVideoCarouselWithSummary from './UM-Base/components/ImageVideoCarouselWithSummary';
import LazyImages from './UM-Base/components/LazyImages';
import ListOfImageAndText from './UM-Base/components/ListOfImageAndText';
import ModalGallery from './UM-Base/components/ModalGallery';
import ModalIframe from './UM-Base/components/ModalIframe';
import ModalMessagebox from './UM-Base/components/ModalMessagebox';
import Overlay from './UM-Base/components/Overlay';
import PopOutBanner from './UM-Base/components/PopOutBanner';
import PreferenceFavourites from './UM-Base/components/PreferenceFavourites';
import PreferenceHeadBtn from './UM-Base/components/PreferenceHeadBtn';
import PreferenceMenu from './UM-Base/components/PreferenceMenu';
import PreferenceModal from './UM-Base/components/PreferenceModal';
import PreferenceUnsubscribe from './UM-Base/components/PreferenceUnsubscribe';
import PreferenceUser from './UM-Base/components/PreferenceUser';
import Product from './UM-Base/components/Product';
import ProductCalendar from './UM-Base/components/ProductCalendar';
import RelatedContent from './UM-Base/components/RelatedContent';
import ScrollComp from './UM-Base/components/ScrollComp';
import SearchBar from './UM-Base/components/SearchBar';
import SearchFilters from './UM-Base/components/SearchFilters';
import SearchMap from './UM-Base/components/SearchMap';
import SearchPredictive from './UM-Base/components/SearchPredictive';
import SearchSubmit from './UM-Base/components/SearchSubmit';
import ShareButton from './UM-Base/components/ShareButton';
import ShowMorePopup from './UM-Base/components/ShowMorePopup';
import StickyNav from './UM-Base/components/StickyNav';
import SubMenu from './UM-Base/components/SubMenu';
import SupportVideo from './UM-Base/components/SupportVideo';
import TabbedContent from './UM-Base/components/TabbedContent';
import VideoGallery from './UM-Base/components/VideoGallery';
import VideoStream from './UM-Base/components/VideoStream';
import VimeoBanner from './UM-Base/components/VimeoBanner';
import WeatherWidget from './UM-Base/components/WeatherWidget';
import AbExperiments from './UM-Base/components/AbExperiments';

// Import routes
import blogSingle from './UM-Base/routes/blog-single';
import search from './UM-Base/routes/search';
// import 'babel-polyfill';
// import "core-js/stable";
// import "regenerator-runtime/runtime";

/**
 * Populate Router instance with DOM routes
 * @type {Router} routes - An instance of our router
 */
const routes = new Router({
  common,
  blogSingle,
  search,
});

/** Load Events */
$(() => {
  // Remove duplicate components and create component router instance
  const components = new ComponentRouter({
    AddToTripModal,
    Alerts,
    AnalyticsOdp,
    Analytics,
    BackToTop,
    BannerCarousel,
    BlogLegend,
    RecentBlogViews,
    RecentBlogsCarousel,
    BookingReviews,
    ChatBotLaunch,
    Countdown,
    DataEvents,
    DeviceResCookie,
    FavButton,
    FitVid,
    FooterLanguageLinks,
    Form,
    Header,
    HeaderSearch,
    ImageParallax,
    ImageVideoCarouselWithSummary,
    LazyImages,
    ListOfImageAndText,
    ModalGallery,
    ModalIframe,
    ModalMessagebox,
    ModalToInternationalSite,
    OidcSignin,
    OidcSilentSignin,
    OidcLogout,
    Overlay,
    PopOutBanner,
    PreferenceFavourites,
    PreferenceHeadBtn,
    PreferenceMenu,
    PreferenceModal,
    PreferenceUnsubscribe,
    PreferenceUser,
    Product,
    ProductCalendar,
    RelatedContent,
    ScrollComp,
    SearchBar,
    SearchFilters,
    SearchMap,
    SearchPredictive,
    SearchSubmit,
    ShareButton,
    ShowMorePopup,
    StickyNav,
    SubMenu,
    SupportVideo,
    TabbedContent,
    TripPlanModal,
    VideoGallery,
    VideoStream,
    VimeoBanner,
    WeatherWidget,
    AbExperiments
  }, window.components.filter((value, index, self) => self.indexOf(value) === index));

  window.componentRouter = components;

  // Why is this here? legacy code?
  moveClassesToBody('.content-wrapper', ['content-wrapper']);

  debugLogger();

  components.registerComponents();
  routes.loadEvents(components);
  components.loadComponents();

  $('[data-toggle="tooltip"]').tooltip();
});
